import { httpPost } from './http'
import type { IFeedback } from '~/types/feedback/models'

const apiEntityPath = '/api/feedback'

export async function createFeedback(entity: IFeedback) {
  const callingMn = createFeedback.name
  const apiPath = apiEntityPath
  return httpPost<IFeedback>({ callingMn, apiPath, entity })
}
